import sanitizeHtml from "sanitize-html";

export const sanitize = (text: string) => {
  return sanitizeHtml(text, {
    allowedAttributes: {p: ['align']}
  })
}